// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2j-2";
export var placeholderIcon = "_2j-3";
export var thumbnailCanvas = "_2j-1";
export var thumbnailWrapper = "_2j-0";